var styles = {"dropdownMenuItem":"styles_dropdown-menu-item__V2K3o","noSpacing":"styles_no-spacing__awCOj","compactSpacing":"styles_compact-spacing__YJ9rs","comfortableSpacing":"styles_comfortable-spacing__1pF3-","looseSpacing":"styles_loose-spacing__6rShp","disabled":"styles_disabled__Ttx92","separator":"styles_separator__NHw9Z"};

export { styles as default };
//# sourceMappingURL=styles.css.js.map
